export enum ETipoRelatorioVenda {
    Simplificado = 1,
    Agrupado = 2
}
